// 简化后的滚动状态模块
export default {
  namespaced: true,
  state: {
    // 只保存右侧菜单的状态
    rightMenuState: null
  },
  mutations: {
    // 保存右侧菜单状态
    SAVE_RIGHT_MENU_STATE(state, stateData) {
      state.rightMenuState = stateData;
    }
  },
  actions: {
    saveRightMenuState({ commit }, stateData) {
      commit('SAVE_RIGHT_MENU_STATE', stateData);
    }
  }
};
